import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { CloseDialog, OpenDialog } from './help-button.actions';
import { HelpButtonState } from './help-button.state';

@Injectable({
  providedIn: 'root'
})
export class HelpButtonDialogFacade {
  private readonly store = inject(Store);

  @Select(HelpButtonState.open) open$: Observable<boolean>;
  @Select(HelpButtonState.title) title$: Observable<string>;
  @Select(HelpButtonState.content) content$: Observable<string>;

  openDialog(title: string, content: string) {
    this.store.dispatch(new OpenDialog(title, content));
  }

  closeDialog() {
    this.store.dispatch(new CloseDialog());
  }
}
